<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="退库日期：">
            <el-date-picker size="medium" v-model="searchForm.START_END_RETURN" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="领料日期：">
            <el-date-picker size="medium" v-model="searchForm.START_END_SEND" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="领料部门：">
            <el-select size="medium" filterable v-model="searchForm.department" style="width: 100%" :clearable="true">
              <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="handleCurrentChange(1)">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="退库单ID" prop="ID" min-width="100px"></el-table-column>
          <el-table-column label="领料单ID" prop="ORDER_ID" min-width="100px"></el-table-column>
          <el-table-column label="领料人" prop="RECEIVER" min-width="100px"></el-table-column>
          <el-table-column label="部门名称" prop="DEPARTMENT_NAME" min-width="100px"></el-table-column>
          <el-table-column label="送货日期" prop="SEND_DAY" min-width="100px"></el-table-column>
          <!-- <el-table-column label="退库人" prop="OPERATION_USER" min-width="100px"></el-table-column> -->
          <el-table-column label="退库日期" prop="OPERATE_DAY" min-width="100px"></el-table-column>
          <!-- <el-table-column label="操作时间" prop="OPERATION_TIME" min-width="100px"></el-table-column> -->
          <el-table-column label="退库金额" prop="TOTAL_FEE" min-width="100px"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openDetail(scope.row)" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <div class="pagination_box" style="text-align: right; margin-top: 10px;">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { queryDepartment } from 'api/productDepart';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      searchForm: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      departmentList: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.SAVE_DSORDER_LIST) {
    //   this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
    //   this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    // } else {
    //   this.currentPage = 1;
    // }
    // // this.$set(this.searchForm, 'PROJECT', this.$store.state.RETURNWAREHOUSE_ALL.PROJECT);
    // this.$set(this.searchForm, 'START_END', this.$store.state.RETURNWAREHOUSE_ALL.START_END);
    // this.$set(this.searchForm, 'START_END_ORDER', this.$store.state.RETURNWAREHOUSE_ALL.START_END_ORDER);
    this.queryDepartment();
    this.queryList();
  },
  methods: {
    // ------------------------拉取数据
    queryList() {
      console.log(this.searchForm);
      // this.$store.dispatch('RETURNWAREHOUSE_ALL', { PROJECT: this.searchForm.PROJECT, START_END: this.searchForm.START_END, START_END_ORDER: this.searchForm.START_END_ORDER });
      const params = {
        SERVICE_ID: '10056',
        OTYPE: 6,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
      };
      if (this.searchForm.START_END_SEND) {
        // params.START_SEND_DAY = this.searchForm.START_END_SEND[0];
        // params.END_SEND_DAY = this.searchForm.START_END_SEND[1];
        [params.START_SEND_DAY, params.END_SEND_DAY] = this.searchForm.START_END_SEND;
      }
      if (this.searchForm.START_END_RETURN) {
        // params.START_RETURN_DAY = this.searchForm.START_END_RETURN[0];
        // params.END_RETURN_DAY = this.searchForm.START_END_RETURN[1];
        [params.START_RETURN_DAY, params.END_RETURN_DAY] = this.searchForm.START_END_RETURN;
      }
      http.post(params)
        .then((result) => {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          if (this.tableData.length == 0) {
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: `${error}1`, type: 'error' });
        });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    openDetail(row) {
      this.$router.push({ path: `/proPickingDocReturnDetail/${row.ID}`, params: { id: row.ID } });
      sessionStorage.setItem('proPickingDocReturnDetailTitle', JSON.stringify(row));
    },
    queryDepartment() {
      queryDepartment().then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/proPickingDocReturn.vue